/* SimGolfer | Rotatable 3D projector placement — product-page enhancement v2
 * Uses optically correct horizontal throw geometry and illustrative, orthographic
 * room geometry. It does not imply verified ceiling clearance or lens shift.
 */
(function(){
'use strict';
var SVG_NS='http://www.w3.org/2000/svg';
var rootSelector='[data-sg-calc="throw"]';
var PROFILES={"BenQ AH500ST":{"shape":[1.06,1.05,0.34],"tone":"#f6f7f2","label":"Compact fixed-lens housing","image":"ah500st-right30.jpg?v=1777685577"},"BenQ AH700ST":{"shape":[1.13,1.14,0.37],"tone":"#2d3431","dark":true,"label":"Motorised-zoom housing","image":"ah700st-right30.jpg?v=1777685591"},"BenQ AK700ST":{"shape":[1.13,1.15,0.38],"tone":"#2a3330","dark":true,"label":"4K golf-projector housing","image":"ak700st-right30.jpg?v=1777685537"},"BenQ LH820ST":{"shape":[1.32,1.02,0.32],"tone":"#edf0ed","label":"Wide short-throw housing","image":"LH820ST-right30.png?v=1777685122"},"BenQ LK936ST":{"shape":[1.46,1.46,0.49],"tone":"#e5eae7","label":"Larger installation housing","image":"lk936st-right30.jpg?v=1777685557"},"BenQ LU935ST":{"shape":[1.47,1.46,0.49],"tone":"#e5eae7","label":"Larger WUXGA installation housing","image":"lu935st-right30.jpg?v=1777685139"}};
function projectorProfile(name){return PROFILES[name] || {shape:[1.17,1.16,.4],tone:"#eaf0ea",label:"Illustrative projector housing",image:null};}
function modelPhoto(name){var p=projectorProfile(name);return p.image?'https://cdn.shopify.com/s/files/1/0935/6738/5937/files/'+p.image:null;}

function clamp(x,a,b){return Math.min(b,Math.max(a,x));}
function ft(x){var inches=Math.max(0,Math.round(x*12));return Math.floor(inches/12)+' ft '+inches%12+' in';}
function tidy(x){return Number(x).toFixed(3).replace(/0+$/,'').replace(/\.$/,'');}
function fmt(x){return Number(x).toFixed(1);}
function rnum(s){return Number.parseFloat(s);}
function fit(width,distance,minRatio,maxRatio){
  if(!(Number.isFinite(width)&&Number.isFinite(distance)&&width>0&&distance>0&&minRatio>0&&maxRatio>=minRatio))return {state:'invalid'};
  var min=width*minRatio,max=width*maxRatio;
  var status=distance < min-0.005?'close':distance > max+0.005?'far':'fit';
  return {state:status,min:min,max:max,image:status==='close'?distance/minRatio:status==='far'?distance/maxRatio:width};
}
var template='<svg class="sgpv-scene" viewBox="0 0 760 420" role="img" aria-label="3D projector and screen placement illustration"></svg>'+
  '<div class="sgpv-move-control"><div class="sgpv-move-heading"><label for="sgpv-move-projector">Move projector</label><output data-pv="move-readout" for="sgpv-move-projector">—</output></div>'+
  '<input id="sgpv-move-projector" data-pv="move" type="range" min="1" max="20" step="0.1" value="5" aria-label="Drag to move projector closer to or farther from the screen">'+
  '<div class="sgpv-move-ends"><span>Closer to screen</span><span>Farther from screen</span></div></div>';
function $p(root,name){return root.querySelector('[data-pv="'+name+'"]');}
function vec(x,y,z){return [x,y,z];}
function add(a,b){return [a[0]+b[0],a[1]+b[1],a[2]+b[2]];}
function sub(a,b){return [a[0]-b[0],a[1]-b[1],a[2]-b[2]];}
function scale(a,v){return [a[0]*v,a[1]*v,a[2]*v];}
function dot(a,b){return a[0]*b[0]+a[1]*b[1]+a[2]*b[2];}
function cross(a,b){return [a[1]*b[2]-a[2]*b[1],a[2]*b[0]-a[0]*b[2],a[0]*b[1]-a[1]*b[0]];}
function norm(a){var n=Math.hypot(a[0],a[1],a[2])||1;return scale(a,1/n);}
function coords(geo,yaw,elevation){
  // Orthographic CAD-style projection of genuine 3D world coordinates.
  var a=yaw*Math.PI/180,b=elevation*Math.PI/180;
  var direction=norm([Math.sin(a)*Math.cos(b),Math.cos(a)*Math.cos(b),Math.sin(b)]);
  var forward=scale(direction,-1),right=norm(cross([0,0,1],forward)),up=norm(cross(forward,right));
  var center=[0,geo.depth*.46,geo.height*.46];
  function projection(p){var d=sub(p,center);return [dot(d,right),dot(d,up)];}
  var half=geo.roomWidth/2,dep=geo.depth,h=geo.height;
  var corners=[];
  for(var x of [-half,half])for(var y of [0,dep])for(var z of [0,h])corners.push(projection([x,y,z]));
  var minX=Math.min.apply(null,corners.map(p=>p[0])),maxX=Math.max.apply(null,corners.map(p=>p[0]));
  var minY=Math.min.apply(null,corners.map(p=>p[1])),maxY=Math.max.apply(null,corners.map(p=>p[1]));
  var k=Math.min(640/Math.max(.1,maxX-minX),323/Math.max(.1,maxY-minY));
  function toScreen(p){var t=projection(p);return [380+(t[0]-(minX+maxX)/2)*k,219-(t[1]-(minY+maxY)/2)*k];}
  return toScreen;
}
function point(p,pr){var t=pr(p);return t[0].toFixed(1)+','+t[1].toFixed(1);}
function path(pts,pr){return pts.map(function(p,i){return (i?'L':'M')+point(p,pr);}).join(' ')+' Z';}
function poly(pts,pr,fill,stroke,opacity,more){
  return '<path d="'+path(pts,pr)+'" fill="'+fill+'" stroke="'+(stroke||'none')+'" stroke-width="'+(more?.strokeWidth||1.2)+'" fill-opacity="'+(opacity==null?1:opacity)+'" '+(more?.dash?'stroke-dasharray="'+more.dash+'"':'')+'/>';
}
function line(a,b,pr,color,strokeWidth,dash){
  return '<path d="M'+point(a,pr)+' L'+point(b,pr)+'" stroke="'+color+'" stroke-width="'+strokeWidth+'" '+(dash?'stroke-dasharray="'+dash+'"':'')+' fill="none"/>';
}
function label(text,pos,pr,dx,dy,cls){
  var p=pr(pos);
  return '<text x="'+(p[0]+(dx||0)).toFixed(1)+'" y="'+(p[1]+(dy||0)).toFixed(1)+'" class="'+(cls||'sgpv-svg-label')+'" text-anchor="middle">'+text+'</text>';
}
function boxMesh(cx,cy,cz,w,d,h,pr,p){
 var l=cx-w/2,r=cx+w/2,b=cy+d/2,f=cy-d/2,z=cz-h/2,t=cz+h/2;
 var top=poly([[l,f,t],[r,f,t],[r,b,t],[l,b,t]],pr,p.tone,'#586e60',1);
 var side=poly([[r,f,z],[r,b,z],[r,b,t],[r,f,t]],pr,p.dark?'#202a25':'#b1c0b8',p.dark?'#121e18':'#667e70',1);
 var front=poly([[l,f,z],[r,f,z],[r,f,t],[l,f,t]],pr,p.dark?'#38413d':'#cbd7d1',p.dark?'#18231d':'#4f6759',1);
 var panel=poly([[l+w*.15,f+d*.22,t+.012],[r-w*.1,f+d*.22,t+.012],[r-w*.1,b-d*.2,t+.012],[l+w*.15,b-d*.2,t+.012]],pr,p.dark?'#444d47':'#e8ede9',p.dark?'#1f2c22':'#b6c6ba',1);
 var vents='';
 for(var j=0;j<5;j++){var x=l+w*(.25+j*.1);vents+=line([x,f-.017,t-.13],[x+w*.052,f-.017,t-.13],pr,'#789287',1.3);}
 return top+side+front+panel+vents;
}
function lensRing(p,pr){
 var v=pr(p),x=v[0].toFixed(1),y=v[1].toFixed(1);
 return '<circle cx="'+x+'" cy="'+y+'" r="7" fill="#1b3e34" stroke="#eaf3ee" stroke-width="1.8"/><circle cx="'+x+'" cy="'+y+'" r="3.1" fill="#71949a"/>';
}
function buildScene(width,distance,result,aspect,yaw,elev,opts){
 opts=opts||{};
 var profile=projectorProfile(opts.model);
  var maxScreen=Math.max(width,result.image||width),height=width/aspect;
  var roomWidth=Math.max(9,width*1.3,maxScreen*1.18),depth=Math.max(11,distance+3.5);
  var roomHeight=Math.max(9.5,height+3.4),bottom=1.15,centerZ=bottom+height/2;
  var scene={roomWidth:roomWidth,depth:depth,height:roomHeight};
  var pr=coords(scene,yaw,elev),half=roomWidth/2;
  var c='#cddcc8',g='#cad8c7';
  var out=[];
  // Clean architectural room: a pale gridded floor, rear wall and transparent outline.
  out.push(poly([[-half,0,0],[half,0,0],[half,depth,0],[-half,depth,0]],pr,'#edf2e9','#ced8cc',1));
  var xStep=Math.max(1,Math.ceil(roomWidth/12));var yStep=Math.max(1,Math.ceil(depth/13));
  for(var x=-half+xStep;x<half;x+=xStep)out.push(line([x,0,.01],[x,depth,.01],pr,'#d6e0d3',.8));
  for(var y=yStep;y<depth;y+=yStep)out.push(line([-half,y,.01],[half,y,.01],pr,'#d6e0d3',.8));
  out.push(poly([[-half,0,0],[half,0,0],[half,0,roomHeight],[-half,0,roomHeight]],pr,'#eaf0e7','#aebead',.51));
  out.push(poly([[-half,0,0],[-half,depth,0],[-half,depth,roomHeight],[-half,0,roomHeight]],pr,'#e3ebe1','#b8c8b5',.18));
  var corners=[[-half,0,0],[half,0,0],[half,depth,0],[-half,depth,0]],tops=corners.map(p=>[p[0],p[1],roomHeight]);
  for(var i=0;i<4;i++){
    out.push(line(corners[i],tops[i],pr,'#bccbbd',1.1,'4 5'));
    if(i!==1)out.push(line(tops[i],tops[(i+1)%4],pr,'#b7c6b9',1,'4 6'));
  }
  // Actual screen rectangle is scaled to selected width and aspect ratio.
  var sw=width/2,sh=height;
  var screen=[[-sw,0,bottom],[sw,0,bottom],[sw,0,bottom+sh],[-sw,0,bottom+sh]];
  out.push(poly(screen,pr,'#f8fbf5','#164632',1,{strokeWidth:5.6}));
  // The image rectangle can overflow the screen when the lens is too far.
  var imgW=Math.max(.1,Number(opts.nativeWidth)||result.image),imgH=Math.max(.1,Number(opts.nativeHeight)||imgW/aspect),offsetZ=centerZ-imgH/2;
  var image=[[-imgW/2,-.035,offsetZ],[imgW/2,-.035,offsetZ],[imgW/2,-.035,offsetZ+imgH],[-imgW/2,-.035,offsetZ+imgH]];
  var lens=[0,distance,centerZ];
  // Light is a genuine volume (four triangular facets joining the lens and image corners).
  out.push(poly([lens,image[2],image[3]],pr,'#c4db9c','#9ab680',.24));
  out.push(poly([lens,image[0],image[1]],pr,'#aacd85','#96b37c',.18));
  out.push(poly([lens,image[0],image[3]],pr,'#cce5b0','none',.23));
  out.push(poly([lens,image[1],image[2]],pr,'#c3da9e','none',.23));
  out.push(poly(image,pr,result.state==='fit'?'#bcd69a':'#e6d4a8','none',.45));
  // Reassert screen perimeter so excess projection is visible but framing remains legible.
  out.push(poly(screen,pr,'none','#174632',1,{strokeWidth:5.5}));
  // Throw ruler measures from optical lens, not projector enclosure/back wall.
  var marker=half*.40;
  out.push(line([marker,0,.09],[marker,distance,.09],pr,'#96742d',2.3,'6 4'));
  var rulerEnd=pr([marker,distance,.09]);
  out.push('<circle cx="'+rulerEnd[0].toFixed(1)+'" cy="'+rulerEnd[1].toFixed(1)+'" r="3.5" fill="#96742d"/>');
  out.push(label(ft(distance),[marker,distance*.57,.1],pr,0,-10,'sgpv-svg-distance'));
  // Floor projection/shadow + floating projector chassis, drawn over the light.
  out.push(poly([[-.55,distance-.38,.06],[.55,distance-.38,.06],[.55,distance+.38,.06],[-.55,distance+.38,.06]],pr,'#92a697','none',.17));
  // Context mat is illustrative; its position is not a certified swing-clearance layout.
  var matD=Math.max(2,Math.min(depth-1,distance*.56));
  out.push(poly([[-1.65,matD-1.3,.04],[1.65,matD-1.3,.04],[1.65,matD+1.3,.04],[-1.65,matD+1.3,.04]],pr,'#739a74','#5c835f',.60));
  var ball=pr([0,matD-.25,.1]);
  out.push('<circle cx="'+ball[0].toFixed(1)+'" cy="'+ball[1].toFixed(1)+'" r="3" fill="#fff" stroke="#315a3f"/>');
  var shape=profile.shape;
  // Front face is drawn behind the exact measured optical-lens position.
  out.push(boxMesh(0,distance+shape[1]*.5,centerZ,shape[0],shape[1],shape[2],pr,profile));
  out.push(lensRing(lens,pr));
  out.push(label('SCREEN',[0,0,bottom+height+.30],pr,0,-8,'sgpv-svg-title'));
  out.push(label('LENS',[0,distance,centerZ+.45],pr,0,-11,'sgpv-svg-label'));
  return '<g class="sgpv-room">'+out.join('')+'</g>';
}
function build(root){
  if(root.dataset.sgpvReady==='minimal'||root.getAttribute('data-sg-calc')!=='throw')return;
  var model=(root.getAttribute('data-model')||'').trim();
  if(!model)return;
  var lo=rnum(root.getAttribute('data-tr-min')),hi=rnum(root.getAttribute('data-tr-max'));
  if(!Number.isFinite(hi))hi=lo;

  var d=root.querySelector('input[data-f="dist"]'),w=root.querySelector('input[data-f="width"]');
  if(!d||!w)return;
  var row=d.parentElement&&d.parentElement.parentElement&&d.parentElement.parentElement.parentElement;
  if(!row||!row.parentNode)return;
  var wrap=document.createElement('div');
  wrap.className='sgpv-minimal-visual';wrap.innerHTML=template;
  row.parentNode.insertBefore(wrap,row);
  root.classList.add('sgpv-minimal');root.dataset.sgpvReady='minimal';
  var svg=wrap.querySelector('.sgpv-scene');
  var slider=wrap.querySelector('[data-pv="move"]');
  var readout=wrap.querySelector('[data-pv="move-readout"]');
  var lensSelect=null,lenses={},previewDefaultLens='',previewLensNote=null;
  var previewLensesOnly=root.hasAttribute('data-preview-lenses');
  try{lenses=JSON.parse(root.getAttribute(previewLensesOnly?'data-preview-lenses':'data-lens-map')||'{}');}catch(e){}
  if(Object.keys(lenses).length){
    previewDefaultLens=root.getAttribute('data-preview-default')||Object.keys(lenses)[0];
    if(!lenses[previewDefaultLens])previewDefaultLens=Object.keys(lenses)[0];
    var chooser=document.createElement('div');chooser.className='sgpv-lens-choice';
    var labelEl=document.createElement('label');labelEl.textContent='Projector lens';
    lensSelect=document.createElement('select');lensSelect.setAttribute('aria-label','Projector lens for 3D placement');
    var placeholder=document.createElement('option');placeholder.value='';placeholder.disabled=true;placeholder.textContent='Projector only — choose a lens';lensSelect.appendChild(placeholder);
    Object.keys(lenses).forEach(function(id){var rec=lenses[id],option=document.createElement('option');option.value=id;option.textContent=rec[2]+' — '+rec[0]+(rec[1]!==rec[0]?'–'+rec[1]:'')+':1';lensSelect.appendChild(option);});
    labelEl.appendChild(lensSelect);chooser.appendChild(labelEl);
    previewLensNote=document.createElement('p');previewLensNote.className='sgpv-scope-note';previewLensNote.textContent='A lens is selected for this preview only. Your purchase selection is unchanged.';chooser.appendChild(previewLensNote);
    wrap.parentNode.insertBefore(chooser,wrap);
    lensSelect.addEventListener('change',function(){
      if(!lensSelect.value)return;
      var id=lensSelect.value,part=lenses[id][2];
      if(previewLensesOnly){
        previewDefaultLens=id;
        root.setAttribute('data-tr-min',lenses[id][0]);
        root.setAttribute('data-tr-max',lenses[id][1]);
        if(rnum(w.value)>0)d.value=(rnum(w.value)*(Number(lenses[id][0])+Number(lenses[id][1]))/2).toFixed(3);
        draw();d.dispatchEvent(new Event('input',{bubbles:true}));return;
      }
      var button=Array.prototype.find.call(document.querySelectorAll('button[data-option-value]'),function(b){return b.getAttribute('data-option-value').indexOf(part)!==-1;});
      if(button){button.click();}
      else{var next=new URL(window.location.href);next.searchParams.set('variant',id);window.location.assign(next.toString());}
    });
  }
  var manualFields=root.querySelector('.sgpv-lens-fields');
  if(manualFields)wrap.parentNode.insertBefore(manualFields,wrap);
  var yaw=35,elev=34;
  var aspect=rnum(root.getAttribute('data-aspect'))||16/9;
  var maxWidth=Number(w.max)||30,maxDistance=Number(d.max)||60;
  d.step='0.001';
  if(!w.value)w.value='10';
  if(!d.value&&rnum(w.value)>0&&lo>0&&hi>=lo)d.value=(rnum(w.value)*(lo+hi)/2).toFixed(3);
  var sliderUpdate=false;
  function draw(){
    lo=rnum(root.getAttribute('data-tr-min'));hi=rnum(root.getAttribute('data-tr-max'));
    if(!Number.isFinite(hi))hi=lo;
    if(lensSelect){
      var currentId=new URLSearchParams(window.location.search).get('variant')||root.getAttribute('data-default-variant')||'';
      var previewOnly=previewLensesOnly||!lenses[currentId];
      var shownId=previewOnly?previewDefaultLens:currentId;
      lensSelect.value=shownId;
      if(previewOnly){lo=Number(lenses[shownId][0]);hi=Number(lenses[shownId][1]);}
      if(previewLensNote)previewLensNote.hidden=!previewOnly;
    }
    root.dataset.sgpvEmpty=!(lo>0&&hi>=lo)?'true':'false';
    if(!(lo>0&&hi>=lo)){
      svg.innerHTML='<text x="380" y="204" fill="#365641" font-size="17" text-anchor="middle">Choose a lens above to see its projection</text>';
      if(root.hasAttribute('data-manual-lens'))svg.querySelector('text').textContent='Enter the fitted lens throw ratio above';
      slider.disabled=true;readout.textContent='—';return;
    }
    if(!d.value&&rnum(w.value)>0)d.value=(rnum(w.value)*(lo+hi)/2).toFixed(3);
    var width=rnum(w.value),distance=rnum(d.value);
    if(!(Number.isFinite(width)&&Number.isFinite(distance)&&width>0&&width<=maxWidth&&distance>0&&distance<=maxDistance)){
      svg.innerHTML='<text x="380" y="204" fill="#365641" font-size="17" text-anchor="middle">Enter valid measurements below</text>';
      slider.disabled=true;
      readout.textContent='—';
      return;
    }
    svg.innerHTML=buildScene(width,distance,fit(width,distance,lo,hi),aspect,yaw,elev,{model:model});
    svg.setAttribute('aria-label',model+': '+ft(distance)+' projector to screen, '+width.toFixed(1)+' ft screen width.');
    // Slider spans the useful throw range and includes any manually entered distance.
    var near=clamp(Math.min(width*lo*.55,distance*.8),.1,maxDistance-1);
    var far=clamp(Math.max(width*hi*1.45,distance*1.2,near+1),near+1,maxDistance);
    slider.disabled=false;
    // Keep the scale fixed while the slider supplies the distance (including keyboard).
    if(!sliderUpdate){
      slider.min=near.toFixed(1);
      slider.max=far.toFixed(1);
    }
    slider.step='0.001';
    slider.value=String(clamp(distance,near,far));
    slider.setAttribute('aria-valuetext',ft(distance)+' from the screen');
    readout.textContent=ft(distance);
  }
  w.addEventListener('input',draw);d.addEventListener('input',draw);
  new MutationObserver(function(){draw();}).observe(root,{attributes:true,attributeFilter:['data-tr-min','data-tr-max']});
  var manualMin=root.querySelector('[data-pv-ratio="min"]'),manualMax=root.querySelector('[data-pv-ratio="max"]');
  function manualLens(){
    var a=manualMin?Number(manualMin.value):NaN,b=manualMax&&manualMax.value?Number(manualMax.value):a;
    if(a>0&&a<=10&&b>=a&&b<=10){root.setAttribute('data-tr-min',a);root.setAttribute('data-tr-max',b);}
    else{root.removeAttribute('data-tr-min');root.removeAttribute('data-tr-max');}
    draw();d.dispatchEvent(new Event('input',{bubbles:true}));
  }
  if(manualMin)manualMin.addEventListener('input',manualLens);
  if(manualMax)manualMax.addEventListener('input',manualLens);
  var note=document.createElement('p');note.className='sgpv-scope-note';
  note.textContent='Placement illustration. Housing and room are illustrative; lens shift, optical offset and swing clearance are not modelled.';
  wrap.appendChild(note);
  // Move the actual projector and sync the existing 'Projector to Screen' field.
  // Native range input supports mouse, touch and keyboard.
  slider.addEventListener('input',function(){
    if(slider.disabled)return;
    sliderUpdate=true;
    try{
      d.value=Number(slider.value).toFixed(3);
      d.dispatchEvent(new Event('input',{bubbles:true}));
    }finally{sliderUpdate=false;}
  });
  // Own pointer drags rather than allowing the browser's native range gesture
  // to pan/autoscroll or scroll the focused control into view. Keyboard stays native.
  var pointerId=null;
  // Keep the room diagram in the same visible position throughout a drag.
  // Prevents Safari focus, scroll anchoring, and trackpad panning from moving the page.
  var dragPin=null, pinFrame=0, releaseTimer=0;
  function preventDragWheel(e){if(dragPin&&e.cancelable)e.preventDefault();}
  function pinPosition(){
    if(!dragPin)return;
    var offset=wrap.getBoundingClientRect().top-dragPin.top;
    if(Number.isFinite(offset)&&Math.abs(offset)>.75)window.scrollBy(0,offset);
  }
  function pinFrameLoop(){
    if(!dragPin)return;
    pinPosition();
    pinFrame=window.requestAnimationFrame(pinFrameLoop);
  }
  function beginPin(){
    if(releaseTimer){clearTimeout(releaseTimer);releaseTimer=0;}
    if(dragPin)return;
    dragPin={top:wrap.getBoundingClientRect().top};
    window.addEventListener('wheel',preventDragWheel,{capture:true,passive:false});
    pinFrame=window.requestAnimationFrame(pinFrameLoop);
  }
  function endPin(){
    if(!dragPin)return;
    pinPosition();
    if(releaseTimer)clearTimeout(releaseTimer);
    // Wait briefly: Safari can adjust scroll position on pointer release.
    releaseTimer=setTimeout(function(){
      pinPosition();
      dragPin=null;
      window.removeEventListener('wheel',preventDragWheel,true);
      if(pinFrame)window.cancelAnimationFrame(pinFrame);
      pinFrame=0;releaseTimer=0;
    },120);
  }
  function moveTo(clientX){
    var rect=slider.getBoundingClientRect();
    var inset=Math.min(10,rect.width/2);
    var fraction=clamp((clientX-rect.left-inset)/Math.max(1,rect.width-2*inset),0,1);
    var min=Number(slider.min),max=Number(slider.max),step=Number(slider.step)||.1;
    slider.value=String(clamp(min+Math.round(fraction*(max-min)/step)*step,min,max));
    slider.dispatchEvent(new Event('input',{bubbles:true}));
    pinPosition();
  }
  if(window.PointerEvent){
    slider.addEventListener('pointerdown',function(e){
      if(slider.disabled||e.isPrimary===false||e.button!==0)return;
      e.preventDefault();
      beginPin();
      pointerId=e.pointerId;
      if(slider.setPointerCapture)try{slider.setPointerCapture(pointerId);}catch(err){}
      try{slider.focus({preventScroll:true});}catch(err){}
      moveTo(e.clientX);
    },{passive:false});
    slider.addEventListener('pointermove',function(e){
      if(e.pointerId!==pointerId)return;
      e.preventDefault();
      moveTo(e.clientX);
    },{passive:false});
    function endPointer(e){
      if(e.pointerId!==pointerId)return;
      pointerId=null;
      if(slider.hasPointerCapture&&slider.hasPointerCapture(e.pointerId))
        slider.releasePointerCapture(e.pointerId);
      if(e.type==='pointerup')slider.dispatchEvent(new Event('change',{bubbles:true}));
      endPin();
    }
    slider.addEventListener('pointerup',endPointer);
    slider.addEventListener('pointercancel',endPointer);
    slider.addEventListener('lostpointercapture',function(){pointerId=null;endPin();});
    // Safari fires touch events alongside pointer events on some devices.
    slider.addEventListener('touchmove',function(e){
      if(dragPin&&e.cancelable)e.preventDefault();
    },{passive:false});
  }else{
    // Legacy Safari / touch browsers without Pointer Events.
    slider.addEventListener('touchstart',function(e){
      if(slider.disabled||e.touches.length!==1)return;
      if(e.cancelable)e.preventDefault();
      beginPin();moveTo(e.touches[0].clientX);
    },{passive:false});
    slider.addEventListener('touchmove',function(e){
      if(slider.disabled||e.touches.length!==1)return;
      if(e.cancelable)e.preventDefault();
      moveTo(e.touches[0].clientX);
    },{passive:false});
    slider.addEventListener('touchend',endPin);
    slider.addEventListener('touchcancel',endPin);
  }
  draw();
  d.dispatchEvent(new Event('input',{bubbles:true}));
}
function boot(scope){
  var nodes=(scope||document).querySelectorAll(rootSelector);
  for(var i=0;i<nodes.length;i++){
    try{build(nodes[i]);}catch(e){if(window.console&&console.error)console.error('3D projector preview unavailable',e);}
  }
}
window.SGProjector3D={render:buildScene,fit:fit,profile:projectorProfile,formatFeet:ft};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot(document);});
else boot(document);
document.addEventListener('shopify:section:load',function(e){boot(e.target||document);});
})();
